export default __webpack_public_path__ + "static/media/revenue_tab_img.7c92da26.png";